module.exports = __webpack_public_path__ + "media/images/talent/mv-slider04-9a992b1f206117a5bc8612af17984f13.png";